<template>
  <q-btn flat small color="info" class="no-margin no-padding" icon="more_vert">
    <q-popover>
      <q-list link>
        <!-- notice `v-close-overlay` which closes popover -->
        <q-item v-close-overlay :to="clientRoute">
          <q-item-side>
            <q-icon name="open_in_new" color="info"></q-icon>
          </q-item-side>
          <q-item-main>
            Edit Record
          </q-item-main>
        </q-item>
        <q-item v-close-overlay link @click.native="handleQuickEdit">
          <q-item-side>
            <q-icon name="open_in_new" color="info"></q-icon>
          </q-item-side>
          <q-item-main>
            Quick Edit Record
          </q-item-main>
        </q-item>
        <template v-if="$route.path === '/event/list'">
          <div>
            <q-item v-close-overlay :to="editRoutes('edit','/attendees')">
              <q-item-side>
                <q-icon name="supervisor account" color="info"></q-icon>
              </q-item-side>
              <q-item-main>
                Attendees
              </q-item-main>
            </q-item>
            <q-item v-close-overlay :to="editRoutes('edit','/groups')" v-if="row.eventType && row.eventType.id && row.eventType.id === 2">
              <q-item-side>
                <q-icon name="group" color="info"></q-icon>
              </q-item-side>
              <q-item-main>
                Groups/Teams
              </q-item-main>
            </q-item>
            <q-item v-close-overlay @click.native="duplicate(row.id)" v-if="row && row.id">
            <!--<q-item v-close-overlay v-if="row && row.id">-->
              <q-item-side>
                <q-icon name="control_point_duplicate" color="info"></q-icon>
                <!--<q-btn flat small color="info" class="no-margin no-padding" icon="more_vert" label="Duplicate" @click="duplicate(row.id)" />-->
              </q-item-side>
              <q-item-main>
                Duplicate
              </q-item-main>
            </q-item>
          </div>
        </template>
        <template v-if="$route.path === '/admin/hr/employees/list'">
          <q-item v-close-overlay :to="editRoutes('hr/timecards', '', '/admin')">
            <q-item-side>
              <q-icon name="access_time" color="info"></q-icon>
            </q-item-side>
            <q-item-main>
              Timecard
            </q-item-main>
          </q-item>
        </template>
        <template v-if="$route.path === '/admin/schools/reports/list'">
          <q-item v-close-overlay @click.native="downloadFile('pdf/manager-visit-reports')">
            <q-item-side>
              <q-icon name="assignment_returned" color="info"></q-icon>
            </q-item-side>
            <q-item-main>
              Download PDF
            </q-item-main>
          </q-item>
        </template>
        <q-item v-close-overlay v-if="user" @click.native="handleLogin">
          <q-item-side>
            <q-icon name="account_circle" color="info"></q-icon>
          </q-item-side>
          <q-item-main>
            Login As User
          </q-item-main>
        </q-item>
      </q-list>
    </q-popover>
  </q-btn>
</template>
<script>
export default {
  name: 'GridCellActionEdit',
  props: {
    column: Object,
    row: Object,
    id: Number,
    resource: String
  },
  computed: {
    clientRoute () {
      return `${this.$store.state[this.resource].clientRoute}/edit/${this.row.id.toString()}`
    },
    user () {
      return this.row.user || this.resource === 'users'
    },
    storePagination: {
      get () {
        return this.$store.state[this.resource].settings.pagination
      },
      set (p) {
        this.$store.commit(`${this.resource}/SET_PAGINATION`, p)
      }
    }
  },
  methods: {
    async downloadFile (url) {
      const BASE_URL = process.env.API_BASE_URL
      // const token = this.$store.getters['auth/token']
      const fullUrl = `${BASE_URL}/${url}/${this.row.id.toString()}`
      this.$download(fullUrl)
    },
    handleQuickEdit () {
      this.$store.commit(`${this.resource}/SET_QUICK_EDIT`, this.id)
    },
    editRoutes (pre, post, customStart = null) {
      if (customStart) {
        return `${customStart}/${pre}/${this.row.id.toString()}${post}`
      } else {
        return `${this.$store.state[this.resource].clientRoute}/${pre}/${this.row.id.toString()}${post}`
      }
    },
    async duplicate (id) {
      let duplicateError = false
      try {
        await this.$axios.post(`/api/event/deepcopy/${id}`)
          .then(response => {
            if (response.status !== 200) {
              duplicateError = true
            }
          }).catch(error => {
            console.log(error)
            duplicateError = true
          })
      } catch (e) {
        console.log(e)
        duplicateError = true
      }
      if (duplicateError) {
        this.$q.notify({
          message: 'Error duplicating event',
          type: 'negative'
        })
      } else {
        // this.$emit('duplicate', true)
        await this.request({ pagination: this.storePagination })
        this.$q.notify({
          message: 'Event duplicated',
          type: 'positive'
        })
      }
    },
    async request ({ pagination = {}, filter = '' }) {
      // console.log('pagination', pagination)
      this.loading = true
      try {
        // // console.log('dispatch?')
        await this.$store.dispatch(`${this.resource}/paginate`, {
          client: this.$axios,
          pagination,
          search: filter,
          trashed: this.trashed ? 1 : null
        })
        this.loading = false
        return Promise.resolve()
      } catch (e) {
        this.loading = false
        // console.log(e)
        return Promise.resolve()
      }
    },
    async handleLogin () {
      try {
        await this.$store.dispatch('auth/loginAsUser', {
          client: this.$axios,
          id: this.resource === 'users' ? this.row.id : this.row.user.id,
          username: this.resource === 'users' ? this.row.username : this.row.user.username
        })
        const roles = this.resource === 'users' ? this.row.roles : this.row.user.roles
        this.$q.notify({
          message: 'Logging you in - you will be directed to their home page',
          type: 'positive'
        })
        this.$nextTick(() => {
          /*
          if (roles && roles.length > 1) {
            this.$q.dialog({
              title: 'Select a Portal',
              message: 'This user has multiple roles, please select which portal to access'
            })
          }
          */
          if (roles.some(role => ['employee'].indexOf(role) >= 0)) {
            this.$router.push({path: '/employee-portal'})
          } else {
            this.$router.push({path: '/customer-portal'})
          }
        })
      } catch (e) {
        // console.log('no go :(')
      }
    }
  }
}
</script>
